import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/shareIcons/arrow-right.svg'


const _hoisted_1 = {
  key: 1,
  class: "flex-square-20 filter-grey"
}

import showAnnotations from '../showAnnotations.vue';
import editExpression from '../editExpression.vue';
import editConceptName from "../editConcept/editConceptName.vue";
import patientapi from "@/api/patientapi";
import { ref, computed } from 'vue';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { useI18n } from "vue-i18n";
import { toastError } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import { PatientSummaryResponseSummaryTypeEnum } from '@/apiGenerate/medserver';


export default /*@__PURE__*/_defineComponent({
  __name: 'rBarMoreMenu',
  props: {
  expr: {
    type: Object,
    required: true,
  },
  isRightBar: {
    type: Boolean,
    default: true,
  },
   refresh: {
    type: Function,
    required: false
  },
  summaryType: {
    type: String,
    required: false
  }
},
  emits: ['setDeletable'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const toast = useToast();
const currentEntryStore = useCurrentEntryStore()

const props = __props

const dropd = ref();

const emits = __emit;

const importanceType = computed(() => {
  return props.expr.summaryType || PatientSummaryResponseSummaryTypeEnum.Basic;
})

async function deleteExpression() {
  if (!currentEntryStore.hasCurrentEntry) return;
  const entryId = currentEntryStore.currentEntryId;

  const expression_CclId = props.expr.expressionCcl.expressionCclId;

  //Frontend
  dropd.value = "";
  //Backend
  try {
    await patientapi.deleteExpression(expression_CclId, entryId, props.expr.patientSummaryId);
  } catch (error: any) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: t(`error.${error.status}`)
    });
  }
  
  if (typeof props.refresh !== 'undefined') {
    props.refresh();
  }

  currentEntryStore.reloadAfterHistoryChange();
}

function showEditConceptName() {
  dropd.value = "EditConcept";
}

function showEditExpression() {
  dropd.value = "EditExpression";
}

function showNlp() {
  dropd.value = "rBarShowAnnotations";
}

function closeFct() {
  dropd.value = "";
}

async function createAndFocusCcl() {
  if (!currentEntryStore.hasCurrentEntry) return;
  const entryId = currentEntryStore.currentEntryId;
  const expressionId = props.expr.expressionId;
  //Frontend
  dropd.value = "";
  //Backend
  const newCcl = await patientapi.addAssessmentCcl(expressionId, entryId);
  await currentEntryStore.reloadAfterHistoryChange();
  currentEntryStore.setConclusionIdToFocusOnExpr(newCcl.conclusionGroupId);

  emits('setDeletable');
}

function openDropDown() {
  if (props.expr.expressionType === 'SubstanceAdministrationPrescription') {
    currentEntryStore.setPoppedSapExpr(props.expr)
  }  
  dropd.value = 'rBarHistoryMenu';
}

async function setNewImportanceType(newImportanceType: string) {
  if (!currentEntryStore.hasCurrentEntry) return;
  const entryId = currentEntryStore.currentEntryId;
  const expressionId = props.expr.expressionId;
  //Frontend
  dropd.value = "";

  //Backend
  await patientapi.setConceptGroupForExpression(expressionId, newImportanceType, entryId, props.expr.patientSummaryId);

  switch (newImportanceType) {
    case 'Monitored': {
      currentEntryStore.setReloadMonitoredData(true);
      break;
    }
    case 'Ecosystem': {
      currentEntryStore.setReloadEcosystemData(true);
      break;
    }
    case 'History': {
      currentEntryStore.setReloadHistoryData(true);
      break;
    }
  }

  if (props.refresh) {
    props.refresh();
  }
  
  currentEntryStore.reloadAfterHistoryChange();
}

return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_list_group = _resolveComponent("list-group")!
  const _component_dbGroup = _resolveComponent("dbGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!

  return (_openBlock(), _createBlock(_component_dropdownBox, {
    modelValue: dropd.value,
    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((dropd).value = $event)),
    openOn: "'rBarHistoryMenu'",
    onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
  }, {
    dropd: _withCtx(() => [
      _createElementVNode("div", {
        class: "bg-modal w-maxC",
        style: {"padding":"0.3rem"},
        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createVNode(_component_dbGroup, null, {
          default: _withCtx(() => [
            _createVNode(_component_list_group, {
              class: "w-full",
              styles: "pad-m",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (createAndFocusCcl()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_svg_item, {
                    icon: "text",
                    styles: "main-l",
                    style: {"margin-top":"-0.1rem"}
                  })
                ]),
                _createVNode(_component_text_item, {
                  txt: _unref(t)('patient.expressionMoreMenu.createGroup'),
                  class: "mleft-04",
                  styles: "main-m"
                }, null, 8, ["txt"])
              ]),
              _: 1
            }),
            (!props.isRightBar)
              ? (_openBlock(), _createBlock(_component_list_group, {
                  key: 0,
                  class: "w-full",
                  styles: "pad-m",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showEditExpression()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_svg_item, {
                        icon: "pencil",
                        styles: "main-l"
                      })
                    ]),
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.expressionMoreMenu.correct'),
                      class: "mleft-04",
                      styles: "main-m"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (props.isRightBar)
              ? (_openBlock(), _createBlock(_component_list_group, {
                  key: 1,
                  class: "w-full",
                  styles: "pad-m",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showEditConceptName()))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_svg_item, {
                        icon: "evolve",
                        styles: "main-l",
                        style: {"margin-top":"-0.1rem"}
                      })
                    ]),
                    _createVNode(_component_text_item, {
                      txt: _unref(t)('patient.expressionMoreMenu.rename'),
                      class: "mleft-04",
                      styles: "main-m"
                    }, null, 8, ["txt"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (props.isRightBar)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _cache[23] || (_cache[23] = _createElementVNode("div", {
                    class: "line-h",
                    style: {"margin-top":"0.4rem","margin-bottom":"0.4rem"}
                  }, null, -1)),
                  (importanceType.value != _unref(PatientSummaryResponseSummaryTypeEnum).Monitored)
                    ? (_openBlock(), _createBlock(_component_list_group, {
                        key: 0,
                        class: "w-full",
                        styles: "pad-m",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (setNewImportanceType('Monitored')))
                      }, {
                        default: _withCtx(() => [
                          _cache[18] || (_cache[18] = _createElementVNode("div", null, [
                            _createElementVNode("img", {
                              src: _imports_0,
                              class: "square-14 filter-grey"
                            })
                          ], -1)),
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.expressionMoreMenu.moveToMonitored'),
                            class: "mleft-04",
                            styles: "main-m"
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (importanceType.value != _unref(PatientSummaryResponseSummaryTypeEnum).History)
                    ? (_openBlock(), _createBlock(_component_list_group, {
                        key: 1,
                        class: "w-full",
                        styles: "pad-m",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (setNewImportanceType('History')))
                      }, {
                        default: _withCtx(() => [
                          _cache[19] || (_cache[19] = _createElementVNode("div", null, [
                            _createElementVNode("img", {
                              src: _imports_0,
                              class: "square-14 filter-grey"
                            })
                          ], -1)),
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.expressionMoreMenu.moveToHistory'),
                            class: "mleft-04",
                            styles: "main-m"
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (importanceType.value != _unref(PatientSummaryResponseSummaryTypeEnum).Ecosystem)
                    ? (_openBlock(), _createBlock(_component_list_group, {
                        key: 2,
                        class: "w-full",
                        styles: "pad-m",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (setNewImportanceType('Ecosystem')))
                      }, {
                        default: _withCtx(() => [
                          _cache[20] || (_cache[20] = _createElementVNode("div", null, [
                            _createElementVNode("img", {
                              src: _imports_0,
                              class: "square-14 filter-grey"
                            })
                          ], -1)),
                          _createVNode(_component_text_item, {
                            txt: _unref(t)('patient.expressionMoreMenu.moveToEcosystem'),
                            class: "mleft-04",
                            styles: "main-m"
                          }, null, 8, ["txt"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_list_group, {
                    class: "w-full",
                    styles: "pad-m",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (setNewImportanceType('Basic')))
                  }, {
                    default: _withCtx(() => [
                      _cache[21] || (_cache[21] = _createElementVNode("div", null, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "square-14 filter-grey"
                        })
                      ], -1)),
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.expressionMoreMenu.removeFromBar'),
                        class: "mleft-04",
                        styles: "main-m"
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  }),
                  (__props.expr.deletable)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _cache[22] || (_cache[22] = _createElementVNode("div", {
                          class: "line-h",
                          style: {"margin-top":"0.4rem","margin-bottom":"0.4rem"}
                        }, null, -1)),
                        _createVNode(_component_list_group, {
                          class: "w-full",
                          styles: "pad-m",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (deleteExpression()))
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_svg_item, {
                                icon: "trash",
                                styles: "main-l",
                                style: {"margin-top":"-0.1rem"}
                              })
                            ]),
                            _createVNode(_component_text_item, {
                              txt: _unref(t)('action.delete'),
                              class: "mleft-04",
                              styles: "main-m"
                            }, null, 8, ["txt"])
                          ]),
                          _: 1
                        })
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_unref(currentEntryStore).showAnnotations)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _cache[24] || (_cache[24] = _createElementVNode("div", {
                    class: "line-h",
                    style: {"margin-top":"0.4rem","margin-bottom":"0.4rem"}
                  }, null, -1)),
                  _createVNode(_component_list_group, {
                    class: "w-full",
                    styles: "pad-m",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (showNlp()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_svg_item, {
                          icon: "lightning",
                          styles: "main-m"
                        })
                      ]),
                      _createVNode(_component_text_item, {
                        txt: _unref(t)('patient.expressionMoreMenu.nlp'),
                        class: "mleft-04",
                        styles: "main-m"
                      }, null, 8, ["txt"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_buttonGroup, {
        styles: "pad-s",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openDropDown()))
      }, {
        default: _withCtx(() => [
          (props.isRightBar)
            ? (_openBlock(), _createBlock(_component_svg_item, {
                key: 0,
                icon: "moreVertical",
                styles: "size-l main-l"
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_svg_item, {
                  icon: "moreVertical",
                  styles: "size-l"
                })
              ]))
        ]),
        _: 1
      }),
      _createVNode(_component_dropdownBox, {
        modelValue: dropd.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dropd).value = $event)),
        openOn: 'EditExpression',
        combo: true
      }, {
        dropd: _withCtx(() => [
          _createVNode(editExpression, {
            expression: __props.expr,
            onClose: _cache[11] || (_cache[11] = ($event: any) => (closeFct()))
          }, null, 8, ["expression"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_dropdownBox, {
        modelValue: dropd.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((dropd).value = $event)),
        openOn: 'EditConcept',
        combo: true
      }, {
        dropd: _withCtx(() => [
          _createVNode(editConceptName, {
            conceptExpression: __props.expr,
            onClose: _cache[13] || (_cache[13] = ($event: any) => (closeFct())),
            editConceptNameDone: props.refresh
          }, null, 8, ["conceptExpression", "editConceptNameDone"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_dropdownBox, {
        modelValue: dropd.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((dropd).value = $event)),
        openOn: 'rBarShowAnnotations'
      }, {
        dropd: _withCtx(() => [
          _createVNode(showAnnotations, { content: __props.expr }, null, 8, ["content"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})